import { debugLog } from './ranking';

export class BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		this.usedFilters = usedFilters;
		this.filtersState = filtersState;
		this.maxRankAfterPunish = 2;
	}
	execute(product) {
		return product.rank;
	}

	logHeadingsToConsole() {}

	executorController(cid, product, callbackClosure) {
		if (product[cid] === null) {
			return 1;
		} else {
			return callbackClosure();
		}
	}

	calculateRankWithFixingZeroValues(product, filterValue, id) {
		if (product[id] === 0 && filterValue === 0) {
			return 1;
		} else if (filterValue === 0) {
			return product[id] + 1;
		} else {
			return product[id] / filterValue;
		}
	}

	calculateRankSingleSliderGTE(id, product, norm) {
		let r = 0;
		const filterValue = this.usedFilters[id] ? this.usedFilters[id] : this.filtersState[id].defaultValue;
		const rank = this.executorController(id, product, () => {
			r = this.calculateRankWithFixingZeroValues(product, filterValue, id);
			return Math.tanh((r - 1) / norm);
		});

		this.rankDebugLog(product, id, r, rank);
		return [rank, r];
	}

	calculateRankSingleSliderLTE(id, product, norm) {
		let r = 0;
		const filterValue = this.usedFilters[id] ? this.usedFilters[id] : this.filtersState[id].defaultValue;
		const rank = this.executorController(id, product, () => {
			r = this.calculateRankWithFixingZeroValues(product, filterValue, id);
			return -Math.tanh((r - 1) / norm);
		});

		this.rankDebugLog(product, id, r, rank);
		return [rank, r];
	}

	calculateRankDualSliderGTE(id, product, norm) {
		let r = 0;
		const filterValue = this.usedFilters[id] ? this.usedFilters[id][0] : this.filtersState[id].defaultValue[0];
		const rank = this.executorController(id, product, () => {
			r = product[id] / filterValue;
			return Math.tanh((r - 1) / norm);
		});

		this.rankDebugLog(product, id, r, rank);
		return [rank, r];
	}

	punishPartsWithNullValueOfUsedFilters(product, usedFilters, feRank) {
		for (let key in usedFilters) {
			if (product[key] === null) {
				return [(feRank += 1), true];
			}
		}
		return [feRank, false];
	}

	rankDebugLog(product, id, r, rank) {
		debugLog.push(product[id]);
		debugLog.push(r);
		debugLog.push(rank);
	}
}
